/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { colors, sizes } from './commonStyles';

/**
 * Переиспользуемые styled components
 */

// Изображения
export const Thumbnail = styled.img<{ size?: 'small' | 'medium' | 'large' }>`
  width: ${props => sizes.thumbnail[props.size || 'small']}px;
  height: ${props => sizes.thumbnail[props.size || 'small']}px;
  object-fit: cover;
  border-radius: 4px;
`;

export const ImagePlaceholder = styled.div<{ size?: 'small' | 'medium' | 'large' }>`
  width: ${props => sizes.thumbnail[props.size || 'small']}px;
  height: ${props => sizes.thumbnail[props.size || 'small']}px;
  background: ${colors.background};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.muted};
`;

// Контейнеры
export const CenterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const LoadingContainer = styled(CenterContainer)`
  padding: 40px;
`;

export const PageContainer = styled.div`
  padding: 20px;
`;

// Грид элементы
export const GridContainer = styled.div`
  max-height: 75vh;
  overflow: auto;
  background: ${colors.backgroundAlt};
  padding: 16px;
  border-radius: 8px;
`;

export const GridRow = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

export const GridHeader = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const RowLabel = styled.div`
  width: 50px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #595959;
  flex-shrink: 0;
`;

export const ColumnLabel = styled.div`
  width: 32px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: ${colors.secondary};
  margin-right: 4px;
`;

export const EmptySpace = styled.div<{ width?: number }>`
  width: ${props => props.width || 50}px;
  flex-shrink: 0;
`;

// Ячейки
export const CellWrapper = styled.div<{ hoverScale?: boolean }>`
  margin-right: 4px;
  transition: all 0.2s;
  position: relative;

  ${props => props.hoverScale && `
    &:hover {
      transform: scale(1.3);
      z-index: 10;

      & > div {
        box-shadow: 0 4px 12px rgba(0,0,0,0.25);
        border: 2px solid ${colors.primary};
      }
    }
  `}
`;

// Текстовые элементы
export const SmallText = styled.span`
  font-size: 12px;
`;

export const TinyText = styled.span`
  font-size: 11px;
`;

export const MicroText = styled.span`
  font-size: 9px;
`;

export const SecondaryText = styled.span`
  color: ${colors.secondary};
`;

export const MutedText = styled.span`
  color: ${colors.muted};
`;

export const HighlightedText = styled.span`
  color: ${colors.primary};
  font-weight: 600;
  font-size: 14px;
`;

// Специфичные элементы plantings
export const PlantingMetaText = styled.div`
  font-size: 12px;
`;

export const PlantingSecondaryText = styled(PlantingMetaText)`
  color: ${colors.secondary};
`;

// Списки
export const StyledList = styled.ul<{ compact?: boolean }>`
  padding-left: ${props => props.compact ? '16px' : '20px'};
  margin-top: ${props => props.compact ? '6px' : '0'};
  margin-bottom: 0;
`;
